import { useState } from "react";

export const useTogglePasswordVisibility = () => {
  const [passwordVisibility, setPasswordVisibility] = useState(true);
  const [rightIcon, setRightIcon] = useState('ios-eye');

  const handlePasswordVisibility = () => {
      if (rightIcon === 'ios-eye') {
        setRightIcon('ios-eye-off-outline');
        setPasswordVisibility(!passwordVisibility);
      } else if (rightIcon === 'ios-eye-off-outline') {
        setRightIcon('ios-eye');
        setPasswordVisibility(!passwordVisibility);
      }
    };
  
    return {
      passwordVisibility,
      rightIcon,
      handlePasswordVisibility
    };
  };
  
  export const useTogglePasswordVisibilityRepeat = () => {
    const [passwordVisibilityRepeat, setPasswordVisibilityRepeat] = useState(true);
    const [rightIconRepeat, setRightIconRepeat] = useState('ios-eye');
  
    const handlePasswordVisibilityRepeat = () => {
        if (rightIconRepeat === 'ios-eye') {
          setRightIconRepeat('ios-eye-off-outline');
          setPasswordVisibilityRepeat(!passwordVisibilityRepeat);
        } else if (rightIconRepeat === 'ios-eye-off-outline') {
          setRightIconRepeat('ios-eye');
          setPasswordVisibilityRepeat(!passwordVisibilityRepeat);
        }
      };
    
      return {
        passwordVisibilityRepeat,
        rightIconRepeat,
        handlePasswordVisibilityRepeat
      };
    };